import React from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import '../../Styles/Header.css'
import Appbar from '../../Component/NavPannel/Appbar';
import CustodinRoutes from '../../Component/Layouts/CustodiansLayout';


const mdTheme = createTheme();

function Custodians() {
 
  return (
    <ThemeProvider theme={mdTheme}>
      <Box sx={{ display: 'flex' }}>
        <CssBaseline />
        <div className='sidebarsetting' >
        <Appbar mainpage="Home" subpage="Custodians"/>
          </div>
        <CustodinRoutes />
      </Box>
    </ThemeProvider>
  );
}

export default function MainCustodians() {
  return <Custodians />
}